import { Platform } from "../../../../../shared/enums/campaignPost.enums";
import { PublicationTemplateType } from "../../data/entities/publication-templates.entity";
import { FacebookCarousel } from "./facebook-carousel";
import { FacebookPost } from "./facebook-post";
import { FacebookStory } from "./facebook-story";
import { GooglePerformanceMax } from "./google-performance-max";
import { InstagramCarousel } from "./instagram-carousel";
import { InstagramSingleImage } from "./instagram-single-image";
import { InstagramStory } from "./instagram-story";

export enum PublicationTemplateStatus {
  Published = "PUBLISHED",
  Scheduled = "SCHEDULED",
  WithIssue = "WITH_ISSUE",
  NotAccepted = "NOT_ACCEPTED",
}

export const PublicationTemplatePlatform: Record<
  PublicationTemplateType,
  Platform
> = {
  [PublicationTemplateType.FacebookCarousel]: Platform.Facebook,
  [PublicationTemplateType.FacebookPost]: Platform.Facebook,
  [PublicationTemplateType.FacebookStory]: Platform.Facebook,
  [PublicationTemplateType.InstagramStory]: Platform.Instagram,
  [PublicationTemplateType.InstagramCarousel]: Platform.Instagram,
  [PublicationTemplateType.InstagramSingleImage]: Platform.Instagram,
  [PublicationTemplateType.GooglePerformanceMax]: Platform.GoogleAds,
};

export interface SchedulePeriod {
  readonly start: Date;
  readonly end?: Date;
}

export class RecommendedSchedule {
  constructor(
    public readonly id: string,
    public readonly publicationTemplateId: string,
    public readonly startDate: Date,
    public readonly endDate?: Date,
  ) {}
}

export interface IPublicationTemplate {
  readonly id: string;
  readonly type: PublicationTemplateType;
  readonly platform: Platform;
  readonly recommendedSchedules: RecommendedSchedule[];
  readonly isAd: boolean;
}

export type FacebookPublication =
  | FacebookCarousel
  | FacebookPost
  | FacebookStory;
export type InstagramPublication =
  | InstagramCarousel
  | InstagramStory
  | InstagramSingleImage;
export type GooglePublication = GooglePerformanceMax;

export type PublicationTemplate =
  | FacebookPublication
  | InstagramPublication
  | GooglePublication;

type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends object ? DeepPartial<T[P]> : T[P];
};

export type PartialPublicationTemplate<Type extends PublicationTemplateType> = {
  type: Type;
} & DeepPartial<PublicationTemplate>;
